export default __webpack_public_path__ + "57937227671cc97d7a97b8dc81ed04aa.png";